import React from 'react';

export default function Support() {
  return (
    <div className="page">
      <h1>User Support</h1>
      <p>
        Welcome to the Dex Support Center. If you’re experiencing issues, have questions, or want to provide feedback about the app, you’re in the right place. We’re here to help ensure your Dex experience is smooth, fun, and fair.
      </p>

      <ol>
        <li>
          <strong>Getting Started</strong><br />
          Need help signing up or logging in? Make sure you’ve downloaded the latest version of Dex from the App Store or Play Store. If you signed up via a third-party provider like Apple or Google, use that option when logging in.
        </li>

        <li>
          <strong>Gameplay Issues</strong><br />
          If you're experiencing issues like:
          <ul>
            <li>Missing or unresponsive buttons</li>
            <li>Slow performance or lag during rounds</li>
            <li>Errors during song playback or voting</li>
          </ul>
          Please restart the app and ensure your internet connection is stable. If the problem persists, contact us with details (see Section 6).
        </li>

        <li>
          <strong>Account Management</strong><br />
          You can manage your Dex account through the app’s settings:
          <ul>
            <li>Change your username or profile picture</li>
            <li>Delete your account</li>
          </ul>
          If you need help recovering a lost account, contact us with the email or username you used.
        </li>
        <li>
          <strong>Bug Reports and Feedback</strong><br />
          Found a bug or want to suggest a new feature? We love hearing from players. Include the following details when reporting:
          <ul>
            <li>Device model and OS version</li>
            <li>App version (found in app settings)</li>
            <li>Steps to reproduce the issue</li>
          </ul>
          This helps us fix problems faster and make Dex better for everyone.
        </li>

        <li>
          <strong>Contact Us</strong><br />
          Our support team is available Monday to Friday, 9am to 6pm (UK time). We aim to respond to all messages within 48 hours.
          <br /><br />
          Email: <a href="mailto:support@dexgame.app">support@dexgame.app</a><br />
        </li>
      </ol>

      <p>
        Thank you for playing Dex — your feedback and support help us keep the beat going.
      </p>
    </div>
  );
}
